import Seller from "./From/Seller";
import Source from "./From/Source";
import Comment from "./Comment";
import React, {Fragment} from "react";
import BoxEditor from "../../BoxEditor";
import PoolList from "./Picking/PoolList";
import Buttons from "../Elements/Buttons";
import List from './List';
import Invoice from "./Invoice";
import Payment from "./Payment";
import Target from "./To/Target";
import Shipping from "./Shipping";
import Notenum from "./Shipping/Notenum";

export default class RetraxitForm extends React.Component {
    render() {
        const componentProps = {...this.props};
        const {props, state, parent} = componentProps;
        const {hidden, labels, actionButtons} = props;
        const Editor = props.editor || BoxEditor;
        return <Fragment>
            <Editor
                theme="default"
                footer={<Fragment>
                    {Array.isArray(actionButtons) ? actionButtons.map((i) => i) : actionButtons}
                </Fragment>}
            >
                {
                    props.values.id && <form onSubmit={props.handleSubmit}>
                        <div className="row form-row">
                            <div className="col-md-6">
                                <Seller {...componentProps} disabled={true} />
                            </div>
                            <div className="col-md-6">
                                <Target {...componentProps} />
                            </div>
                        </div>
                        <Invoice {...componentProps}/>
                        <div className="row form-row">
                            <Payment {...componentProps} />
                        </div>
                        <div className="row form-row">
                            <Shipping {...componentProps} />
                        </div>
                        <Comment {...componentProps} />
                        <PoolList {...componentProps} control={{visible: false}}/>
                    </form>
                }
            </Editor>
        </Fragment>;
    }
}